export default __webpack_public_path__ + "static/media/gallery-wip-blade plug_07.fc79fd44.jpg";